import { useForm } from 'react-hook-form';

import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { FormProvider, RHFSwitch, RHFTextField } from '../../components/hook-form';

import { useQueryClient } from '@tanstack/react-query';
import useIsLargerThan from 'src/hooks/useIsLargerThan';
import { networkInsertHost, networkUpdateHost } from 'src/network/host';
import useAppInfoStore from 'src/store/appInfo';
import useFormsModalStore from 'src/store/forms';
import { getDefaultValues } from './defaultValues';

// ----------------------------------------------------------------------

const TAB_MENU_ITEMS = [
  {
    value: 'SECTION',
    label: 'بخش',
  },
  {
    value: 'GAME',
    label: 'تک بازی',
  },
  {
    value: 'MEDIA_PLAYLIST',
    label: 'فهرست پخش رسانه',
  },
  {
    value: 'GAME_PLAYLIST',
    label: ' فهرست بازی ها',
  },
];

// ----------------------------------------------------------------------

export default function HostForm() {
  const { enqueueSnackbar } = useSnackbar();

  const { projectId, feedId } = useParams();

  const queryClient = useQueryClient();

  const isLargerThenLg = useIsLargerThan('lg');

  const { modal, closeModal } = useFormsModalStore();

  const currentData = modal?.data?.current;

  const [isLoading, setIsLoading] = useState(false);

  const { appInfo } = useAppInfoStore();

  // ----------------------------------------------------------------------
  const defaultValues = getDefaultValues(currentData);
  const isEditMode = modal?.data?.isEditMode;

  const methods = useForm({
    // resolver: yupResolver(schema), // todo schema
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      ...values,
      HostOwnerActiveADSL: !!values?.HostOwnerActiveADSL ? 1 : 0,
      HostOwnerActiveMCI: !!values?.HostOwnerActiveMCI ? 1 : 0,
      HostOwnerActiveMTN: !!values?.HostOwnerActiveMTN ? 1 : 0,
      HostOwnerActiveRightel: !!values?.HostOwnerActiveRightel ? 1 : 0,

      HostOwnerPriceADSL: !!values?.HostOwnerPriceADSL ? Number(values?.HostOwnerPriceADSL) : 0,
      HostOwnerPriceMCI: !!values?.HostOwnerPriceMCI ? Number(values?.HostOwnerPriceMCI) : 0,
      HostOwnerPriceMTN: !!values?.HostOwnerPriceMTN ? Number(values?.HostOwnerPriceMTN) : 0,
      HostOwnerPriceRIGHTEL: !!values?.HostOwnerPriceRIGHTEL ? Number(values?.HostOwnerPriceRIGHTEL) : 0,

      HostOwnerReducePercentADSL: !!values?.HostOwnerReducePercentADSL ? Number(values?.HostOwnerReducePercentADSL) : 0,
      HostOwnerReducePercentMCI: !!values?.HostOwnerReducePercentMCI ? Number(values?.HostOwnerReducePercentMCI) : 0,
      HostOwnerReducePercentMTN: !!values?.HostOwnerReducePercentMTN ? Number(values?.HostOwnerReducePercentMTN) : 0,
      HostOwnerReducePercentRightel: !!values?.HostOwnerReducePercentRightel ? Number(values?.HostOwnerReducePercentRightel) : 0,
    };

    try {
      setIsLoading(true);
      if (!!isEditMode) {
        const res = await networkUpdateHost(currentData?.HostOwnerID, PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ویرایش شد');
          closeModal();
          reset();
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      } else {
        const res = await networkInsertHost(PAYLOAD);
        if (res.data?.items?.ResultID !== -1) {
          enqueueSnackbar('آیتم موردنظر با موفقیت ثبت شد');
          closeModal();
          reset();
        } else {
          enqueueSnackbar('خطایی رخ داد !', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      await queryClient.invalidateQueries({ queryKey: 'traffic-report-own-host' });
    }
  };

  return (
    <>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ p: 3 }}>
              <>
                <RHFTextField name="HostOwnerLable" type="text" label="عنوان" />
                <TableContainer sx={{ position: 'relative' }}>
                  <Table size="medium" border={10}>
                    <TableHead>
                      <TableRow>
                        <TableCell>قیمت</TableCell>
                        <TableCell>کسورات</TableCell>
                        <TableCell>وضعیت</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerPriceMTN" type="number" label=" ایرانسل" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerReducePercentMTN" type="number" label=" ایرانسل" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFSwitch name="HostOwnerActiveMTN" labelPlacement="end" label="" />
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerPriceMCI" type="number" label=" همراه اول" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerReducePercentMCI" type="number" label=" همراه اول" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFSwitch name="HostOwnerActiveMCI" labelPlacement="end" label="" />
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerPriceADSL" type="number" label=" مخابرات" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerReducePercentADSL" type="number" label=" مخابرات" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFSwitch name="HostOwnerActiveADSL" labelPlacement="end" label="" />
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerPriceRIGHTEL" type="number" label=" رایتل" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFTextField name="HostOwnerReducePercentRightel" type="number" label=" رایتل" />
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body1">
                            <RHFSwitch name="HostOwnerActiveRightel" labelPlacement="end" label="" />
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <div className="flex items-center gap-4 mt-6">
                  <LoadingButton type="submit" variant="contained" name="save" loading={isSubmitting}>
                    ذخیره
                  </LoadingButton>
                  <Button onClick={() => closeModal()} variant="contained" color="error">
                    انصراف
                  </Button>
                </div>
              </>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </>
  );
}
